import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import PersonAndTeam from "@coworker/apprestructured/src/task-management/components/PersonAndTeam/PersonAndTeam";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "./Actions/Actions";
import FixaRadioButton from "@coworker/apprestructured/src/shared/wrappers/FixaRadioButton/FixaRadioButton";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";

type UserVariant = "value" | "null" | "undefined";
type TeamVariant = "value" | "undefined";

function PersonAndTeamDemo() {
  const [title, setTitle] = useState("Assigned to");
  const [user, setUser] = useState("Sofie Assarsson");
  const [team, setTeam] = useState("HFB 01 - Living room seating");
  const [userVariant, setUserVariant] = useState<UserVariant>("value");
  const [teamVariant, setTeamVariant] = useState<TeamVariant>("value");

  return (
    <Demo>
      <Name>PersonAndTeam</Name>
      <Highlight>
        <PersonAndTeam
          title={title}
          user={
            userVariant === "value"
              ? user
              : userVariant === "null"
                ? null
                : LOADING
          }
          team={teamVariant === "value" ? team : LOADING}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="title"
          type="text"
          id="personandteamdemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaInputField
          label="user"
          type="text"
          id="personandteamdemo-user"
          value={user}
          onChange={(e) => setUser(e.target.value)}
        />
        <FixaInputField
          label="team"
          type="text"
          id="personandteamdemo-team"
          value={team}
          onChange={(e) => setTeam(e.target.value)}
        />
        <div>
          <FixaRadioButton
            id="userValue"
            name="userValue"
            checked={userVariant === "value"}
            onChange={() => setUserVariant("value")}
            label="userValue (has loaded user)"
          />
          <FixaRadioButton
            id="userNull"
            name="userNull"
            checked={userVariant === "null"}
            onChange={() => setUserVariant("null")}
            label="userNull (no user)"
          />
          <FixaRadioButton
            id="userUndefined"
            name="userUndefined"
            checked={userVariant === "undefined"}
            onChange={() => setUserVariant("undefined")}
            label="userUndefined (loading user)"
          />
        </div>
        <div>
          <FixaRadioButton
            id="teamValue"
            name="teamValue"
            checked={teamVariant === "value"}
            onChange={() => setTeamVariant("value")}
            label="teamValue (has loaded team)"
          />
          <FixaRadioButton
            id="teamUndefined"
            name="teamUndefined"
            checked={teamVariant === "undefined"}
            onChange={() => setTeamVariant("undefined")}
            label="teamUndefined (loading team)"
          />
        </div>
      </Actions>
    </Demo>
  );
}

export default memo(PersonAndTeamDemo);
